import React from 'react';
import PropTypes from 'prop-types';
import { faPlay } from '@fortawesome/free-solid-svg-icons/faPlay';

import { PlayBtn, PlayIcon } from './styles';

const PlayButton = ({ className, onClick }) => {
  return (
    <PlayBtn
      onClick={onClick}
      className={className}
      type="button"
      aria-label="Play YouTube video."
      aria-haspopup="dialog"
    >
      <PlayIcon icon={faPlay} />
    </PlayBtn>
  );
};

PlayButton.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};

PlayButton.defaultProps = {
  className: null,
};

export default PlayButton;
